<template>
    <div class="users-style">


        <div class="clearfix row py-2 mb-3 no-margin">
            <div class="col-sm-6 pl-0">
                <div class="custom-search">
                    <b-input-group class="mb-0">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>


                </div>
            </div>
            <div class=" col-sm-6 text-right pr-0">
                <b-button :href="$api_url+'/employee/leave/import/template?flag=1'"><b-icon icon="code-slash" ></b-icon> Template </b-button>
                 <b-button @click="$bvModal.show('bv-modal-import-carry');"><b-icon icon="box-arrow-up" class="" scale="1"></b-icon> Import </b-button>
            </div>

        </div>

               <div class="row justify-content-center no-margin">
                <!-- alpha fix- added class border  -->
            <table class="table dataTable border">
                <thead>
                    <tr class="table-head">
                        <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span>{{column.label}}</span></th>

                    </tr>
                </thead>
                <tbody>
                    <tr class="hover-bg table-row mx-2" v-for="user in paginatedData" :key="user.id">
                        <td>{{user.name}}</td>
                        <td>{{user.employee_code}}</td>
                        <td>{{user.carry_string}}</td>
                    </tr>
                    <tr v-if="paginatedData.length > 0"><td :colspan="6">
                    <div class="row p-2 float-right" >
                        <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                    </div></td></tr>
                    <!-- alpha fix- added class text-center  -->
                    <tr class="text-center" v-if="paginatedData.length == 0"><td :colspan="6">{{blankmsg}}</td></tr>
                </tbody>
            </table>


        </div>

        <b-modal id="bv-modal-import-carry" size="lg" hide-footer title="Import Carrying Data">
            <div class="row clearfix mb-2"><div class="col-md-12">Click browse and upload file</div></div>
            <!-- alpha fix added class mb-5 to the b-form-file to give some margin bottom so that the file input is not too close to the modal footer -->
            <b-form-file class="mb-5" id="carryfile" name="carryfile" @change="uploadCarryFile"  accept=".xlsx,.xls"></b-form-file>
        </b-modal>

        <ul class="list-group my-3" v-if="errormsg.length > 0">
            <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{error}}</li>
            <li class="list-group-item list-group-item-success" >Success : All other inputs have been imported successfully!</li>
        </ul>





    </div>
</template>


<script>
    export default{

        mounted() {
        },
        data(){
            let sortOrders = {};
            let columns = [
                            {label: 'Name', name: 'name' },
                            {label: 'Employee Code', name: 'employee_code'},
                            {label: 'Days Carried Forward', name: 'carry_string'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});

            return {


                columns: columns,
                sortKey: 'name',
                sortOrders: sortOrders,

                search:'',

                blankmsg : 'Fetching data..',

                carrying_data:[],

                length: 20,
                pagination: {currentPage: 1, total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

                errormsg : {},
            }
        },

        created: function(){
            this.getCarryingData();
        },
        methods:{
            getCarryingData: function()
            {
                this.showoverlay_list = true;
                if(!this.checkNet()) return false;

                this.$bvModal.hide('bv-modal-leave-details');
                let currentObj = this;
                axios.get(this.$api_url + '/carrying-data' , {
                    params: {

                    }
                }).then(function(response){
                    //this.showoverlay_list = false;

                    this.carrying_data = response.data;

                    if(this.carrying_data.length == 0)
                        this.blankmsg = "No records found.";

                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            uploadCarryFile:function(event)
            {
                if(!this.checkNet()) return false;
                this.uploaded_file_data = this.$api_url+"/leave-attendances";
                this.showoverlay = true;
                this.errormsg = {};

                let currentObj = this;
                // this function upload the logo
                this.empfile = event.target.files[0];

                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);

                axios.post(this.$api_url+'/carry/import', data , config).
                    then(function (response)
                    {
                        this.errormsg = response.data;
                        this.$bvToast.toast('Successfully Completed', {
                                            title: `Success`,
                                            variant: 'info',
                                            solid: true
                                        });

                        this.showoverlay = false;

                        this.$bvModal.hide('bv-modal-import-carry');
                        this.getCarryingData();


                    }.bind(this)).catch(function (error){ currentObj.serverError(error);});
                    this.showoverlay = false;
            },
        },
        computed:
        {

            filteredData()
            {
                let filtered_list = this.carrying_data;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date')
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            else if (this.columns[index].type && this.columns[index].type === 'number')
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
